import React from 'react';
import PropTypes from 'prop-types';
import { withTracker } from 'meteor/react-meteor-data';
import { Meteor } from 'meteor/meteor';

import { isEmpty } from 'lodash';

import {
  Box,
  Checkbox,
  FormControl,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Select,
  Typography
} from '@mui/material';
import Loading from '../../Loading';

import Connectors from '../../../../api/Connectors/Connectors';
import TelemetryConnections from '../../../../api/TelemetryConnections/TelemetryConnections';

const TemplatePointCloudItemEdit = ({
  serverConnection,
  connectors,
  loading,
  connections,
  setConnections
}) => {
  if (loading) return <Loading />;

  const [connectorSelected, setConnectorSelected] = React.useState({});
  const [serverSelected, setServerSelected] = React.useState({});
  const [sourceSelected, setSourceSelected] = React.useState([]);
  const [allSources, setAllSources] = React.useState([]);

  const handleDownloadLinkComponent = (serverProps, sourceProps, connectorProps) => {
    setConnections({
      server: serverProps,
      source: isEmpty(sourceProps) ? [] : sourceProps,
      connector: isEmpty(connectorProps) ? {} : connectorProps,
      importFile: connections.importFile
    });
  };

  const handleToggle = item => {
    const currentIndex = sourceSelected.findIndex(el => el.name === item.name);
    const newChecked = [...sourceSelected];
    if (currentIndex === -1) {
      newChecked.push(item);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setSourceSelected(newChecked);
    handleDownloadLinkComponent(serverSelected, newChecked, connectorSelected);
  };

  const callToBack = async serverProp => {
    const urlFunction = () => {
      let url;
      if (serverProp.serverType === 'IGP') {
        url = `http://${serverProp.ip}:${serverProp.port}/MG/lidar/write_lidar_html`;
      } else if (serverProp.serverType === 'IGPS' || serverProp.serverType === 'input') {
        url = `${serverProp.domain}/MG/lidar/write_lidar_html`;
      }
      return url;
    };
    const response = await fetch(urlFunction(), {
      method: 'POST',
      body: JSON.stringify({
        ftpIp: '',
        ftpPort: '',
        ftpUser: '',
        ftpPassword: '',
        httpPort: '',
        disc: 'data3',
        projectName: 'Request',
        projectPath: '',
        projectsEntwine: '',
        position: ''
      }),
      headers: { 'Content-Type': 'application/json' },
      mode: 'cors',
      credentials: 'omit',
      referrerPolicy: 'no-referrer'
    });
    const respuesta = await response.json();
    setAllSources(respuesta);
  };

  return (
    <>
      <Box>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="demo-select-label">Base de datos</InputLabel>
          <Select
            labelId="demo-select-label"
            id="demo-select"
            label="Base de datos"
            size="small"
            value={connectorSelected.name}
            onChange={event => {
              const fullConector = connectors.find(element => element.name === event.target.value);
              handleDownloadLinkComponent(serverSelected, sourceSelected, fullConector);
              setConnectorSelected(fullConector);
            }}
          >
            {connectors.map(item => (
              <MenuItem key={item.name} value={item.name}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="demo-select-label">Conexión IPS</InputLabel>
          <Select
            labelId="demo-select-label"
            id="demo-select"
            label="Conexión IPS"
            size="small"
            value={serverSelected.name}
            onChange={event => {
              const serverSelectedSearch = serverConnection.find(
                element => element.name === event.target.value
              );
              callToBack(serverSelectedSearch);
              setServerSelected(serverSelectedSearch);
              handleDownloadLinkComponent(serverSelectedSearch, sourceSelected, connectorSelected);
            }}
          >
            {serverConnection.map(item => (
              <MenuItem key={item.name} value={item.name}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <Box display="column" width="75%" spacing={1}>
        <Typography>Sources</Typography>
        <div style={{ maxHeight: '50vh', overflow: 'auto' }}>
          <List>
            {allSources.map(item => (
              <ListItem key={item.name} button onClick={() => handleToggle(item)}>
                <Checkbox
                  edge="start"
                  checked={sourceSelected.findIndex(el => el.name === item.name) !== -1}
                  tabIndex={-1}
                  disableRipple
                  sx={{
                    color: '#2A3F90',
                    '&.Mui-checked': {
                      color: '#2A3F90'
                    }
                  }}
                />
                <ListItemText primary={item.name} secondary={item.path} />
              </ListItem>
            ))}
          </List>
        </div>
      </Box>
    </>
  );
};
TemplatePointCloudItemEdit.defaultProps = {
  connections: {},
  setConnections: () => {}
};

TemplatePointCloudItemEdit.propTypes = {
  serverConnection: PropTypes.array.isRequired,
  connectors: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  connections: PropTypes.object,
  setConnections: PropTypes.func
};

export default withTracker(() => {
  const connectionsSub = Meteor.isClient && Meteor.subscribe('telemetryConnections');
  const connectorsSub = Meteor.subscribe('connectors');

  return {
    loading: !connectionsSub.ready() && !connectorsSub.ready(),
    serverConnection: TelemetryConnections.find({ serverType: { $in: ['IGP', 'IGPS'] } }).fetch(),
    connectors: Connectors.find({ deleted: { $eq: 'no' }, type: 'PostgreSQL' }).fetch()
  };
})(TemplatePointCloudItemEdit);
